const e = {
  step: "Step {{current}} out of {{max}}. {{name}}",
  title: {
    first: "Your vehicle",
    second: "Your vehicle",
    third: "Vehicle parameters",
    fourth: "Vehicle parameters",
    success: "Cost calculation"
  }
}, t = {
  title: "Alas, it was not possible to make the calculation",
  description: "Unfortunately, we were unable to find results that fit all the criteria you selected. Try changing some of the parameters.",
  noEstimate: {
    title: "There's no estimate",
    description: "For rare, run-down and new cars, you won't be able to calculate a market price."
  },
  startAgain: "Start over"
}, a = {
  goTo: "Fill in the parameters manually",
  back: "Back",
  forward: {
    default: "Continue",
    byStage: {
      third: "Calculate cost",
      fourth: "Calculate cost"
    }
  }
}, r = {
  estimatedPrice: {
    title: "Estimated redemption cost",
    noData: "No data"
  },
  save: "Save result",
  reset: "Start over"
}, s = {
  errors: {
    required: "This field is required",
    incorrect: "Invalid value",
    emptyListValues: "Failed to retrieve the list of values"
  }
}, o = {
  stageHeader: e,
  errorStage: t,
  stage: a,
  successStage: r,
  field: s
};
export {
  o as default,
  t as errorStage,
  s as field,
  a as stage,
  e as stageHeader,
  r as successStage
};
